/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Alert } from 'sarsaparilla';

import {
    AdditionalChallengeRequiredAlert,
    RecaptchaFailedAlert,
} from 'shared-ui/recaptcha';

export type CreateAccountErrorType =
    | 'invalidCellPhone'
    | 'additionalChallenge'
    | 'recaptchaFailed'
    | 'existingAccount'
    | 'unknown'
    | null;

interface CreateAccountErrorsProps {
    errorType: CreateAccountErrorType;
    className?: string;
}

export function CreateAccountErrors({ errorType, className }: CreateAccountErrorsProps) {
    if (errorType === null) {
        return null;
    }

    if (errorType === 'invalidCellPhone') {
        return (
            <Alert
                type="error"
                className={className}
                heading="Invalid Mobile Phone"
                shouldFocusOnMount
            >
                Please enter a valid cell phone number.
            </Alert>
        );
    }

    if (errorType === 'additionalChallenge') {
        return <AdditionalChallengeRequiredAlert className={className} />;
    }

    if (errorType === 'recaptchaFailed') {
        return <RecaptchaFailedAlert className={className} />;
    }

    if (errorType === 'existingAccount') {
        return (
            <Alert
                type="error"
                className={className}
                heading="Existing Account"
                shouldFocusOnMount
            >
                An account with this email already exists. Please login or use a different
                email.
            </Alert>
        );
    }

    return (
        <Alert
            type="error"
            className={className}
            heading="Unknown Error"
            shouldFocusOnMount
        >
            Something went wrong while trying to create your account. Please try again in
            a moment. If the problem persists, try refreshing the page.
        </Alert>
    );
}
